import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import {
  PaginateQuery,
  CreateSchoolRequest,
  UpdateSchoolRequest,
} from "../../interfaces";

export const schoolApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSchools: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/school"),
      }),
      providesTags: ["Paginated-Schools"],
    }),
    getSchool: builder.query<any, string>({
      query: (id) => ({ url: `/api/school/${id}` }),
      providesTags: ["School"],
    }),
    getSchoolSelectList: builder.query<
      any,
      { governorateId: string; cityId: string }
    >({
      query: ({ governorateId, cityId }) => ({
        url: `/api/school/select-list/all?governorateId=${governorateId}&cityId=${cityId}`,
      }),
      providesTags: ["School-Select-List"],
    }),
    addSchool: builder.mutation<any, CreateSchoolRequest>({
      query: (data) => ({
        url: "/api/school",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["School", "Paginated-Schools", "School-Select-List"],
    }),
    updateSchool: builder.mutation<
      any,
      { id: string; data: UpdateSchoolRequest }
    >({
      query: ({ id, data }) => ({
        url: `/api/school/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["School", "Paginated-Schools", "School-Select-List"],
    }),
    deleteSchool: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/school/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Paginated-Schools", "School-Select-List"],
    }),
  }),
});

export const {
  useGetSchoolsQuery,
  useGetSchoolQuery,
  useGetSchoolSelectListQuery,
  useAddSchoolMutation,
  useUpdateSchoolMutation,
  useDeleteSchoolMutation,
} = schoolApi;
